<fieldset class="is-flex is-flex-direction-column is-gap-1">
  <h3>{{ 'tarificateur.area.coverage' | translate }}</h3>

  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.coverage.subtitle' | translate }}</h4>
    <p>
      {{ coverageZone }}
    </p>
  </div>

  <div class="is-flex is-flex-direction-column">
    <div class="is-flex is-align-items-center is-gap-1">
      <h4>{{ 'tarificateur.coverage.country' | translate }}</h4>
      <acs-info-bulle
        infoBulleMessage="{{
            'tarificateur.secondpays.tooltip' | translate
          }}"></acs-info-bulle>
    </div>
    <mat-form-field class="width-full">
      <input type="text"
             placeholder="{{ 'country.expat' | translate }}"
             [formControl]="expatAdditionalCountryFC"
             [readonly]="isCountrySelected()"
             matInput
             [matAutocomplete]="autoAdd"
             #addTrigger="matAutocompleteTrigger"
             (focus)="addTrigger.openPanel()"
             (click)="addTrigger.openPanel()">
      <mat-autocomplete #autoAdd="matAutocomplete" [displayWith]="displayAddCountry">
        @for (state of addCountriesOptions(); track state) {
          <mat-option [value]="state.alpha3">{{ state.label }}</mat-option>
        }
      </mat-autocomplete>
      @if (expatAdditionalCountryFC.value) {
        <button mat-icon-button matSuffix type="button" (click)="clearCountry($event, addTrigger)" [attr.aria-label]="'Clear'">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  @if (alreadyCovered === 'Non') {
    <div class="is-flex is-flex-direction-column">
      <div class="is-flex is-align-items-center is-gap-1">
        <h4>
          {{ 'tarificateur.couverturenationalite' | translate }}
        </h4>
        <acs-info-bulle
          infoBulleMessage="{{
              'tarificateur.couverturenationalite.tooltip' | translate
            }}"></acs-info-bulle>
      </div>
      <mat-radio-group
        class="is-flex gap-s"
        [formControl]="expatCoverNationalityCountryFC">
        <mat-radio-button value="Oui">
          {{ 'key.yes' | translate }}
        </mat-radio-button>
        <mat-radio-button value="Non">
          {{ 'key.no' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  } @else if (
    alreadyCovered === 'non_applicable'
    ) {
    <div class="is-flex is-align-items-center is-gap-1">
      <h4>
        {{ 'subscription.cover.impossible' | translate }}
      </h4>
      <acs-info-bulle
        infoBulleMessage="{{
              'tarificateur.couverturenationalite.tooltip' | translate
            }}"></acs-info-bulle>
    </div>
  } @else {
    <div class="is-flex is-align-items-center is-gap-1">
      <h4>
        {{ 'subscription.already.covered' | translate }}
      </h4>
      <acs-info-bulle
        infoBulleMessage="{{
              'tarificateur.couverturenationalite.tooltip' | translate
            }}"></acs-info-bulle>
    </div>
  }
</fieldset>
